// @ts-nocheck
import styled from 'styled-components';
import { TABLET_SMALL_WIDTH } from 'commons/constants';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { greyscale },
} = getTheme();
const ProgramGroupWrapper: StatelessFunctionalComponent<any> = styled.div`
  margin-bottom: 1.6rem;

  .row {
    margin: 0 -1.2rem;
  }

  .col {
    &-sm-4,
    &-lg-3 {
      padding: 0 1.2rem 2.4rem 1.2rem !important;
    }
  }

  .program-group {
    &__name {
      color: ${greyscale.mineShaft};
      font-size: 3rem;
      line-height: 4.2rem;
      margin-bottom: 2.4rem;
    }
  }

  @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
    .row {
      flex-wrap: nowrap;
    }

    .col {
      &-sm-4 {
        max-width: unset;
      }
    }

    .program-card {
      width: 22rem;
    }

    .program-group {
      &__cards-container {
        overflow-x: scroll;
      }
    }
  }
`;
export default ProgramGroupWrapper;
